import {
  Box,
  Grid,
  Paper,
  Typography,
  Button,
} from "@mui/material";
import CustomModal from "../../components/custom-modal/CustomModal";
import FormikControl from "../../bmr/components/common/FormikControl";
import {
  DocumentOutlined,
  UserOutlined,
  PhaseIcon,
  ProductDetailsDashboardIcon,
  UserDashboardIcon
} from "../../assets/common-svg/CommonSvg";
import { useSelector } from "react-redux";
import { getUserHasAccess } from "../../utils/authorities";
import { useEffect, useState, useMemo } from "react";
import { useFormik } from "formik";
import EditorApi from "../../services/editorManagementService";
import { notify } from "../../bmr/utils/methods/notification";
import { useNavigate } from "react-router";

const ActionButtons = () => {
  const LoginData = useSelector((state) => state.loginData);
  const userAuthority = LoginData?.auth || [];
  const role_id = LoginData.role_id;
  const role_slug =LoginData.role_slug

  const [open, setOpen] = useState(false);

  const [productData, setProductData] = useState([]);
  const [allPhaseData, setAllPhaseData] = useState([]);
  const [filteredPhaseData, setFilteredPhaseData] = useState([]);

  const [modalTitle, setModalTitle] = useState("");
  const navigate = useNavigate();
  // Check permissions
  const hasAddPatientPermission = getUserHasAccess(userAuthority, "subject", 16);
  const hasAddProductPermission=getUserHasAccess(userAuthority, "product", 78);
    const hasAddPhasePermission=getUserHasAccess(userAuthority, "trials", 10);
    const hasAddUserPermission=getUserHasAccess(userAuthority, "userManagement", 50);
  const hasAddVisitPermission = getUserHasAccess(
    userAuthority,
    "appointmentManager",
    122
  );

  // Calculate grid size based on number of buttons
  const getGridSize = () => {
    if (hasAddPatientPermission && hasAddProductPermission && hasAddPhasePermission && hasAddUserPermission) {
      return { xs: 3, md: 3 }; // Show in 4 columns when all permissions exist
    }
    if (hasAddPatientPermission && hasAddVisitPermission) {
      return { xs: 6, md: 6 }; // Show in 6 columns when both permissions exist
    }
    return { xs: 12, md: 12 }; // Full width when only one permission
  };

  const getAllPhaseDropDown = async () => {
    try {
      let editor_id = undefined;
      let user_id = undefined;
      let investigator_id = undefined;

      if (role_slug === 'editor') {
        editor_id = LoginData.loginId;
      }

      if (role_slug === 'investigator') {
        investigator_id = LoginData.loginId;
      }
      if (role_slug === 'project-manager') {
        user_id = LoginData.loginId;
      }

      const res = await EditorApi.getPhaseDropDown(
        "", // search
        investigator_id, // investigator_id
        editor_id, // editor_id (only for role 5)
        user_id
      );

      const phases = res.data.map((item) => ({
        id: item.id,
        name: item.title,
        productId: item.product_details?.id || null,
      }));

      const products = res.data
        .filter((item) => item.product_details)
        .map((item) => ({
          id: item.product_details.id,
          name: item.product_details.name,
        }));

      const uniqueProducts = Array.from(
        new Map(products.map((p) => [p.id, p])).values()
      );
      const sortedProducts = uniqueProducts.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
        );
      setProductData(sortedProducts);
      setAllPhaseData(phases);
      setFilteredPhaseData(phases);
    } catch (error) {
      notify.error(error);
    }
  };

  useEffect(() => {
    if (open) {
      getAllPhaseDropDown();
    }
  }, [open]);

  // Formik form configuration
  const initialValues = {
    product: "",
    phase: "",
  };


const isAddPhase = modalTitle === "Add Phase";

  const handleSubmit = async (values) => {
  // 🚫 Stop redirection if product or phase is missing
  if (isAddPhase) {
  if (!values.product) return;
} else {
  if (!values.product || !values.phase) return;
}

  const selectedProduct = productData.find((p) => p.id === values.product);
  const selectedPhase = filteredPhaseData.find((p) => p.id === values.phase);

  if (modalTitle === "Add Patient") {
    if (role_id === 1) {
      navigate(`/products/product-details/${selectedProduct?.id}`);
    } else {
      navigate(`/phases/phase-details/${selectedPhase?.id}`);
    }
  }

  if (modalTitle === "Add New Visit") {
    if (role_id === 1) {
      navigate(`/products/product-details/${selectedProduct?.id}`);
    } else {
      navigate(`/phases/phase-details/${selectedPhase?.id}`);
    }
  }
if (modalTitle === "Add Phase") {
    if (role_id === 1) {
      navigate(`/products/product-details/${selectedProduct?.id}`);
    }
    else {
      navigate(`/phases/phase-details/${selectedPhase?.id}`);
    }
  }
  handleCloseModal();
};

 const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });
  // const isFormValid = Boolean(formik.values.product && formik.values.phase);
  const isFormValid = isAddPhase
  ? Boolean(formik.values.product)
  : Boolean(formik.values.product && formik.values.phase);


  const handleCloseModal = () => {
    setOpen(false);
    formik.resetForm();
    setFilteredPhaseData(allPhaseData);
  };

const formOptions = useMemo(() => {
  const options = [
    {
      label: "Product",
      type: "select",
      name: "product",
      required: true,
      placeholder: "Select Product",
      options: productData.map((product) => ({
        label: product.name,
        value: product.id,
      })),
      onChange: (e) => {
        const product = productData.find((p) => p.id === e.target.value);
        formik.setFieldValue("product", e.target.value);
        formik.setFieldValue("phase", "");

        if (product) {
          setFilteredPhaseData(
            allPhaseData.filter((phase) => phase.productId === product.id)
          );
        } else {
          setFilteredPhaseData(allPhaseData);
        }
      },
    },
  ];

  if (!isAddPhase) {
    options.push({
      label: "Phase",
      type: "select",
      name: "phase",
      required: true,
      placeholder: "Select Phase",
      options: filteredPhaseData.map((phase) => ({
        label: phase.name,
        value: phase.id,
      })),
    });
  }

  return options;
}, [productData, filteredPhaseData, allPhaseData, formik, isAddPhase]);

  return (
    <Box sx={{ pb: 3 }}>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {/* Add Patient */}
        {hasAddPatientPermission && (
          <Grid item {...getGridSize()}>
            <Paper
              elevation={0}
              sx={{
                height: 90,
                borderRadius: 2,
                border: "1px solid #E5E7EB",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": { backgroundColor: "#F9FAFB" },
              }}
              onClick={() => {
                setOpen(true);
                setModalTitle("Add Patient");
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={0.5}
              >
                <UserOutlined />
                <Typography fontWeight={500} color="text.secondary">
                  Add Patient
                </Typography>
              </Box>
            </Paper>
          </Grid>
        )}
        {hasAddProductPermission && (
        <Grid item {...getGridSize()}>
  <Paper
    elevation={0}
    sx={{
      height: 90,
      borderRadius: 2,
      border: "1px solid #E5E7EB",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": { backgroundColor: "#F9FAFB" },
    }}
    onClick={() => navigate("/products")}  
  >
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={0.5}
    >
      <ProductDetailsDashboardIcon/>
      <Typography fontWeight={500} color="text.secondary">
        Add Product
      </Typography>
    </Box>
  </Paper>
</Grid>
        )}
{hasAddPhasePermission && (
        <Grid item {...getGridSize()}>
  <Paper
    elevation={0}
    sx={{
      height: 90,
      borderRadius: 2,
      border: "1px solid #E5E7EB",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": { backgroundColor: "#F9FAFB" },
    }}
       onClick={() => {
                setOpen(true);
                setModalTitle("Add Phase");
              }}
  >
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={0.5}
    >
      <PhaseIcon/>
  
      <Typography fontWeight={500} color="text.secondary">
        Add Phase
      </Typography>
    </Box>
  </Paper>
</Grid>
        )}
{hasAddUserPermission && (
        <Grid item {...getGridSize()}>
  <Paper
    elevation={0}
    sx={{
      height: 90,
      borderRadius: 2,
      border: "1px solid #E5E7EB",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": { backgroundColor: "#F9FAFB" },
    }}
    onClick={() => navigate(`/onboard-users`)}  
  >
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={0.5}
    >
      <UserDashboardIcon/>
      <Typography fontWeight={500} color="text.secondary">
        Add User
      </Typography>
    </Box>
  </Paper>
</Grid>
        )}

        {/* Add New Visit */}
        {hasAddVisitPermission && (
          <Grid item {...getGridSize()}>
            <Paper
              elevation={0}
              sx={{
                height: 90,
                borderRadius: 2,
                border: "1px solid #E5E7EB",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": { backgroundColor: "#F9FAFB" },
              }}
              onClick={() => {
                setOpen(true);
                setModalTitle("Add New Visit");
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={0.5}
              >
                <DocumentOutlined />
                <Typography fontWeight={500} color="text.secondary">
                  Add New Visit
                </Typography>
              </Box>
            </Paper>
          </Grid>
        )}
      </Grid>

      <CustomModal
        ModalTitle={modalTitle}
        open={open}
        setOpen={handleCloseModal}
      >
        <form onSubmit={formik.handleSubmit}>
          <Box display="flex" flexDirection="column" gap={2} padding={3}>
            <Grid container spacing={2}>
              {formOptions.map((props, key) => (
                <Grid key={key} item xs={12}>
                  <FormikControl formik={formik} {...props} />
                </Grid>
              ))}
            </Grid>
            <Box display="flex" justifyContent="center" gap={1} mt={2}>
              {/* <Button variant="contained" type="submit">
                {modalTitle}
              </Button> */}
              <Button
                variant="contained"
                type="submit"
                disabled={!isFormValid}
              >
                {modalTitle}
              </Button>

            </Box>
          </Box>
        </form>
      </CustomModal>
    </Box>
  );
};

export default ActionButtons;
